module.exports = "<rw-button ng-class=\"$ctrl.classes\"\r\n           variant=\"outlined\"\r\n           action=\"$ctrl.resetPassword()\">\r\n   <translate>\r\n     Reset password\r\n   </translate>\r\n</rw-button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/components/reset-account-password/components/reset-password-button/reset-password-button.html
// module id = 1178
// module chunks = 0